/**
 * Guidance text describing the next action for the current stage and the caller's experience, or
 * null when the stage needs no guidance (ACTIVE/INACTIVE). Rendered as inline muted helper text
 * under the DTA title in the header (see DataStreamHeader); it is contextual help, not a
 * dismissible banner.
 */
export function stageGuidanceText(
  displayStage: string | undefined,
  isDAE: boolean | undefined,
  isVendor: boolean | undefined,
  userApproved: boolean,
): string | null {
  if (!displayStage || displayStage === "ACTIVE" || displayStage === "INACTIVE") return null
  if (displayStage === "DRAFT" && isDAE) {
    return "Configure the transfer specification, then submit for Review."
  }
  if (displayStage === "DRAFT" && isVendor) {
    return "The DAE is preparing this DTA. You'll be notified when it's ready for Review."
  }
  if (displayStage === "REVIEW" && isVendor) {
    return userApproved
      ? "You have approved. Waiting for other reviewers."
      : "Review the DTA details and approve, or request changes."
  }
  if (displayStage === "REVIEW" && isDAE) {
    return userApproved
      ? "You have approved. Waiting for remaining reviewers."
      : "Review the DTA and approve to advance the workflow."
  }
  if (displayStage === "APPROVED" && isDAE) {
    return "All approvals received. Activate the DTA to begin accepting data."
  }
  if (displayStage === "APPROVED" && isVendor) {
    return "Waiting for DAE to activate this DTA."
  }
  return null
}
